import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';
import styles from './BlogSection.module.css';
import translationService from '../../services/translationService';

function BlogSection({ lang = 'ar' }) {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLatestBlogs = async () => {
      try {
        const blogsQuery = query(
          collection(db, 'blogs'),
          orderBy('createdAt', 'desc'),
          limit(3)
        );
        
        const blogsSnapshot = await getDocs(blogsQuery);
        const blogsData = blogsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt?.toDate?.() || new Date(doc.data().createdAt)
        }));
        
        setBlogs(blogsData);
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setError('Failed to load blog posts');
      } finally {
        setLoading(false);
      }
    };

    fetchLatestBlogs();
  }, []);

  if (loading) {
    return (
      <section className={styles.blogSection}>
        <h2>Latest Blog Posts</h2>
        <div className={styles.loading}>Loading blog posts...</div>
      </section>
    );
  }

  if (error) {
    return (
      <section className={styles.blogSection}>
        <h2>Latest Blog Posts</h2>
        <div className={styles.error}>{error}</div>
      </section>
    );
  }

  if (blogs.length === 0) {
    return (
      <section className={styles.blogSection}>
        <h2>Latest Blog Posts</h2>
        <div className={styles.noBlogs}>No blog posts available yet.</div>
      </section>
    );
  }

  return (
    <section className={styles.blogSection}>
      <h2>Latest Blog Posts</h2>
      <div className={styles.blogGrid}>
        {blogs.map(blog => {
          const getTranslatedContent = (field) => translationService.getTranslatedContent(blog, field, lang);
          return (
            <article key={blog.id} className={styles.blogCard}>
              <div className={styles.blogImage}>
                <img src={blog.imageUrl} alt={getTranslatedContent('title')} />
              </div>
              <div className={styles.blogContent}>
                <h3>{getTranslatedContent('title')}</h3>
                <p className={styles.blogMeta}>
                  By {blog.author} • {blog.createdAt.toLocaleDateString()}
                </p>
                <p className={styles.blogSummary}>{getTranslatedContent('summary')}</p>
                <Link to={`/blog/${blog.id}`} className={styles.readMore}>
                  Read More
                </Link>
              </div>
            </article>
          );
        })}
      </div>
      <Link to="/blog" className={styles.viewAllButton}>
        View All Posts
      </Link>
    </section>
  );
}

export default BlogSection; 